module.exports = __webpack_public_path__ + "img/generated-1772441615240.b4426a22.png";